export default {"src":"/_next/static/media/apple-store-logo.5b9df203.svg","height":40,"width":135};